/**
 * One billing read on Settings (TMMAPP-0112, the 0103 / 0105 amendment): `BillingProfileProvider`
 * loads `GET /v1/me/billing` once, and every section reads it through `useBillingProfile()`. A
 * section that changes billing calls `reload()`, which keeps the profile on screen while it re-reads.
 */
import { createContext, useContext } from 'react';
import type { BillingProfile } from '@/api/billing';

export interface BillingProfileState {
  /** `idle` when the person has no billing to read (not a subscriber, not locked). */
  status: 'idle' | 'loading' | 'ready' | 'error';
  profile: BillingProfile | null;
  error: unknown;
  reload: () => Promise<void>;
}

const IDLE: BillingProfileState = {
  status: 'idle',
  profile: null,
  error: undefined,
  reload: async () => {},
};

export const BillingProfileContext = createContext<BillingProfileState>(IDLE);

export function useBillingProfile(): BillingProfileState {
  return useContext(BillingProfileContext);
}
